import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Panel, Btn, fmt, useOps } from "./ui";

export default function DigestPanel() {
  const { api } = useOps();
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/digest").then((r) => setD(r.data)), [api]);
  useEffect(() => { load(); }, [load]);
  const send = async () => { await api.post("/digest/send"); toast.success("Digest queued"); setTimeout(load, 3000); };
  if (!d) return null;
  const last = d.last;
  return (
    <Panel title="Morning beta digest (7:00 AM ET)" className="lg:col-span-3" testid="health-digest" actions={<>
      <Btn variant="ghost" onClick={load} data-testid="digest-refresh">Refresh preview</Btn>
      <Btn onClick={send} data-testid="digest-send-now">Send now</Btn>
    </>}>
      <div className="mb-2 text-[11px] text-slate-400">
        To: <span className="mono">{d.to || "ALERT_EMAIL not set"}</span> · Postmark: {d.postmark ? "on" : "off"} · Last:{" "}
        <span data-testid="digest-last-status" className={last?.ok ? "text-green-400" : last ? "text-red-400" : ""}>
          {last ? `${last.ok ? "sent" : "not sent"} ${fmt(last.at)}${last.error ? ` — ${last.error}` : ""}` : "never"}
        </span>
      </div>
      <pre data-testid="digest-preview-text" className="mono max-h-80 overflow-auto whitespace-pre-wrap rounded bg-[#0b0f17] p-3 text-[11px] leading-5 text-slate-200">{d.text}</pre>
    </Panel>
  );
}
